"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iHome = exports.iInvitations = exports.iGroups = void 0;
const t = require("io-ts");
exports.iGroups = t.interface({
    id: t.number,
    name: t.string
});
exports.iInvitations = t.interface({
    id: t.number,
    emails: t.string,
    uuid: t.string
});
exports.iHome = t.interface({
    status: t.string,
    removeStatus: t.string,
    groupStatus: t.string,
    invitingStatus: t.string,
    inviteModal: t.boolean,
    list: t.union([t.null, t.array(exports.iGroups)]),
    inviteUsers: t.union([t.null, t.array(exports.iInvitations)]),
    shortcuts: t.union([t.null, t.array(t.string)]),
});
//# sourceMappingURL=home.js.map